<template>
	<v-dialog v-model="dialog" persistent max-width="500px">
		<v-card>
			<v-toolbar flat dense cad>
					<v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>
				<v-card-text>
					<v-text-field v-model="form.name" :error-messages="nameErrors" label="Name" required @input="$v.form.name.$touch()" @blur="$v.form.name.$touch()"></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="closeEditor">Cancel</v-btn>
					<v-btn color="primary" flat @click="submit">Save</v-btn>
				</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		props: {
			department: {
				type: Object,
				default: () => ({
					id: null,
					name: null
				})
			},
			dialog: {},
			title: {
				required: true,
				type: String
			}
		},
		data() {
			return {
				form: {
					id: this.department.id,
					name: this.department.name
				}
			};
		},
		watch: {
			department() {
				this.form = {
					id: this.department.id,
					name: this.department.name
				};
			}
		},
		computed: {
			nameErrors() {
				const errors = [];
				if (!this.$v.form.name.$dirty) return errors;
				!this.$v.form.name.required && errors.push('Name is required.');
				return errors;
			}
		},
		mixins: [validationMixin],

		validations: {
			form: {
				name: { required }
			}
		},
		methods: {
			submit() {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					let postObj = {
						id: this.form.id != undefined ? this.form.id : null,
						name: this.form.name
					};
					this.$emit('save', postObj);
					this.closeEditor();
				}
			},
			closeEditor() {
				this.clear();
				this.$emit('closeEditor');
			},
			clear() {
				this.$v.form.$reset();
				this.form = {
					id: null,
					name: null
				};
			}
		}
	};
</script>

<style></style>
